module.exports = __webpack_public_path__ + "img/spirit_f.dbb1665a.png";